// Auto-generated by scripts/generateItemAssets.js
// itemKeywordMap.json check=1 entries are the only confirmed Korean display names.
import ItemAsset__007__Deathadder_Queen_0 from "../assets/items/weapon/007. Deathadder Queen.png";
import ItemAsset__008__Black_Mamba_King_1 from "../assets/items/weapon/008. Black Mamba King.png";
import ItemAsset__009__Alpha_Sidewinder_2 from "../assets/items/weapon/009. Alpha Sidewinder.png";
import ItemAsset__012__Hiking_Boots_3 from "../assets/items/leg/012. Hiking Boots.png";
import ItemAsset__013__Virtuous_Outlaw_4 from "../assets/items/head/013. Virtuous Outlaw.png";
import ItemAsset__013__Glacier_Crampons_5 from "../assets/items/leg/013. Glacier Crampons.png";
import ItemAsset__014__Steel_Knee_Pads_6 from "../assets/items/leg/014. Steel Knee Pads.png";
import ItemAsset__014__Sword_Stopper_7 from "../assets/items/arm/014. Sword Stopper.png";
import ItemAsset__014__Crystal_Tiara_8 from "../assets/items/head/014. Crystal Tiara.png";
import ItemAsset__015__Feather_Boots_9 from "../assets/items/leg/015. Feather Boots.png";
import ItemAsset__016__Maverick_Runner_10 from "../assets/items/leg/016. Maverick Runner.png";
import ItemAsset__016__Vital_Sign_Censor_11 from "../assets/items/arm/016. Vital Sign Censor.png";
import ItemAsset__017__Helm_of_Banneret_12 from "../assets/items/head/017. Helm of Banneret.png";
import ItemAsset__017__Creed_of_the_Knight_13 from "../assets/items/arm/017. Creed of the Knight.png";
import ItemAsset__018__Bucephalus_14 from "../assets/items/leg/018. Bucephalus.png";
import ItemAsset__018__Sheath_of_Shah_Jahan_15 from "../assets/items/arm/018. Sheath of Shah Jahan.png";
import ItemAsset__019__Sunset_Armor_16 from "../assets/items/chest/019. Sunset Armor.png";
import ItemAsset__019__Burnished_Aegis_17 from "../assets/items/arm/019. Burnished Aegis.png";
import ItemAsset__019__White_Rhinos_18 from "../assets/items/leg/019. White Rhinos.png";
import ItemAsset__020__Mohawk_Headgear_19 from "../assets/items/head/020. Mohawk Headgear.png";
import ItemAsset__020__Tachyon_Brace_20 from "../assets/items/leg/020. Tachyon Brace.png";
import ItemAsset__021__Optical_Camouflage_Suit_21 from "../assets/items/chest/021. Optical Camouflage Suit.png";
import ItemAsset__022__Diadem_22 from "../assets/items/head/022. Diadem.png";
import ItemAsset__022__Rocker_s_Jacket_23 from "../assets/items/chest/022. Rocker_s Jacket.png";
import ItemAsset__022__Stellar_Steps_24 from "../assets/items/leg/022. Stellar Steps.png";
import ItemAsset__022__Plasma_Arc_25 from "../assets/items/arm/022. Plasma Arc.png";
import ItemAsset__023__Crusader_Armor_26 from "../assets/items/chest/023. Crusader Armor.png";
import ItemAsset__023__Smart_Band_27 from "../assets/items/arm/023. Smart Band.png";
import ItemAsset__023__Cowboy_Hat_28 from "../assets/items/head/023. Cowboy Hat.png";
import ItemAsset__023__Cowboy_Boots_29 from "../assets/items/leg/023. Cowboy Boots.png";
import ItemAsset__024__Gladiator_30 from "../assets/items/leg/024. Gladiator.png";
import ItemAsset__024__Minuteman_Armband_31 from "../assets/items/arm/024. Minuteman Armband.png";
import ItemAsset__024__Amazoness_Armor_32 from "../assets/items/chest/024. Amazoness_Armor.png";
import ItemAsset__024__Plasma_Helmet_33 from "../assets/items/head/024. Plasma Helmet.png";
import ItemAsset__025__Dragon_Dobok_34 from "../assets/items/chest/025. Dragon Dobok.png";
import ItemAsset__025__Welding_Helmet_35 from "../assets/items/head/025. Welding Helmet.png";
import ItemAsset__027__Laced_Quiver_36 from "../assets/items/arm/027. Laced Quiver.png";
import ItemAsset__027__Fox_Mask_37 from "../assets/items/head/027. Fox Mask.png";
import ItemAsset__027__Butler_s_Suit_38 from "../assets/items/chest/027. Butler_s Suit.png";
import ItemAsset__028__Jolly_Roger_39 from "../assets/items/arm/028. Jolly Roger.png";
import ItemAsset__028__EOD_Suit_40 from "../assets/items/chest/028. EOD Suit.png";
import ItemAsset__029__The_Sailor_41 from "../assets/items/head/029. The Sailor.png";
import ItemAsset__029__Music_Box_42 from "../assets/items/arm/029. Music Box.png";
import ItemAsset__029__Tuxedo_43 from "../assets/items/chest/029. Tuxedo.png";
import ItemAsset__030__Schr_dinger_s_Box_44 from "../assets/items/arm/030. Schrödinger_s Box.png";
import ItemAsset__031__Changpao_45 from "../assets/items/chest/031. Changpao.png";
import ItemAsset__032__Turnout_Coat_46 from "../assets/items/chest/032. Turnout Coat.png";
import ItemAsset_Uniform_47 from "../assets/items/chest/Uniform.png";
import ItemAsset__010__Deathadder_Queen_MT_48 from "../assets/items/weapon/010. Deathadder Queen MT.png";
import ItemAsset__011__Deathadder_Queen_FC__49 from "../assets/items/weapon/011. Deathadder Queen FC_.png";
import ItemAsset__012__Black_Mamba_King_TL_50 from "../assets/items/weapon/012. Black Mamba King TL.png";
import ItemAsset__013__Black_Mamba_King_FC_51 from "../assets/items/weapon/013. Black Mamba King FC.png";
import ItemAsset__014__Alpha_Siderwinder_ML_52 from "../assets/items/weapon/014. Alpha Siderwinder ML.png";
import ItemAsset__015__Alpha_Sidewinder_FC_53 from "../assets/items/weapon/015. Alpha Sidewinder FC.png";
import ItemAsset__027__Mithril_Boots_54 from "../assets/items/leg/027. Mithril Boots.png";
import ItemAsset__028__EOD_Boots_EOD____55 from "../assets/items/leg/028. EOD Boots_EOD 부츠.png";
import ItemAsset__030__Mithril_Helm_56 from "../assets/items/head/030. Mithril Helm.png";
import ItemAsset__030__Iron_Maiden_57 from "../assets/items/leg/030. Iron Maiden.png";
import ItemAsset__031__Laurel_Wreath_58 from "../assets/items/head/031. Laurel Wreath.png";
import ItemAsset__031__Boots_of_Hermes_59 from "../assets/items/leg/031. Boots of Hermes.png";
import ItemAsset__032__Mithril_Shield_60 from "../assets/items/arm/032. Mithril Shield.png";
import ItemAsset__032__Blade_Boots_61 from "../assets/items/leg/032. Blade Boots.png";
import ItemAsset__032__Crusader_Helmet_62 from "../assets/items/head/032. Crusader Helmet.png";
import ItemAsset__033__Mithril_Armor_63 from "../assets/items/chest/033. Mithril Armor.png";
import ItemAsset__033__Alexander_64 from "../assets/items/leg/033. Alexander.png";
import ItemAsset__033__Cube_Watch_65 from "../assets/items/arm/033. Cube Watch.png";
import ItemAsset__034__Battle_Suit_66 from "../assets/items/chest/034. Battle Suit.png";
import ItemAsset__034__Elysian_Halo_67 from "../assets/items/head/034. Elysian Halo.png";
import ItemAsset__035__Blazing_Dress_68 from "../assets/items/chest/035. Blazing Dress.png";
import ItemAsset__035__Fallen_Pegasus_69 from "../assets/items/head/035. Fallen Pegasus.png";
import ItemAsset__035__Wild_Walkers_70 from "../assets/items/leg/035. Wild Walkers.png";
import ItemAsset__036__Galaxy_Steps_71 from "../assets/items/leg/036. Galaxy Steps.png";
import ItemAsset__036__Radar_72 from "../assets/items/arm/036. Radar.png";
import ItemAsset__036__Mithril_Crop_73 from "../assets/items/chest/036. Mithril Crop.png";
import ItemAsset__037__Mirage_Lace_Ups_74 from "../assets/items/leg/037. Mirage Lace-Ups.png";
import ItemAsset__037__Auto_arms_75 from "../assets/items/arm/037. Auto-arms.png";
import ItemAsset__038__Centipede_s_Pauldron_76 from "../assets/items/arm/038. Centipede_s Pauldron.png";
import ItemAsset__038__Racing_Boots_77 from "../assets/items/leg/038. Racing Boots.png";
import ItemAsset__039__Space_Boots_78 from "../assets/items/leg/039. Space Boots.png";
import ItemAsset__039___o_D_i_79 from "../assets/items/chest/039. Áo Dài.png";
import ItemAsset__039__The_Star_of_the_Wilds_80 from "../assets/items/head/039. The Star of the Wilds.png";
import ItemAsset__040__Shield_of_Kings_81 from "../assets/items/arm/040. Shield of Kings.png";
import ItemAsset__040__Tactical_Shoes_82 from "../assets/items/leg/040. Tactical Shoes.png";
import ItemAsset__040__Phantom_Jacket_83 from "../assets/items/chest/040. Phantom Jacket.png";
import ItemAsset__041__Guardian_Suit_84 from "../assets/items/chest/041. Guardian Suit.png";
import ItemAsset__041__Dwarf_s_Helmet_85 from "../assets/items/head/041. Dwarf_s Helmet.png";
import ItemAsset__042__Chain_of_Thorns_86 from "../assets/items/arm/042. Chain of Thorns.png";
import ItemAsset__042__Twilight_87 from "../assets/items/head/042. Twilight.png";
import ItemAsset__043__Beautiful_Garnment_88 from "../assets/items/chest/043. Beautiful Garnment.png";
import ItemAsset__043__GPNVG_89 from "../assets/items/head/043. GPNVG.png";
import ItemAsset__044__Specter_90 from "../assets/items/chest/044. Specter.png";
import ItemAsset__044__Helix_91 from "../assets/items/arm/044. Helix.png";
import ItemAsset__045__Mythril_Armband_92 from "../assets/items/arm/045. Mythril Armband.png";
import ItemAsset__046__Blaster_Helmet_93 from "../assets/items/head/046. Blaster Helmet.png";
import ItemAsset__046__Omert__94 from "../assets/items/chest/046. Omertà.png";
import ItemAsset__046__Buccaneer_Doubloon_95 from "../assets/items/arm/046. Buccaneer Doubloon.png";
import ItemAsset__047__Moonlight_Pendant_96 from "../assets/items/arm/047. Moonlight Pendant.png";
import ItemAsset__047__Shooting_Star_Jacket_97 from "../assets/items/chest/047. Shooting Star Jacket.png";
import ItemAsset__047__Commander_Headset_98 from "../assets/items/head/047. Commander Headset.png";
import ItemAsset__048__Blue_Flames_99 from "../assets/items/head/048. Blue Flames.png";
import ItemAsset__049__Mythril_Quiver_100 from "../assets/items/arm/049. Mythril Quiver.png";
import ItemAsset__049__Bunny_Hat_101 from "../assets/items/head/049. Bunny Hat.png";
import ItemAsset__049__Tactical_Armor_102 from "../assets/items/chest/049. Tactical Armor.png";
import ItemAsset__050__Legatus_103 from "../assets/items/head/050. Legatus.png";
import ItemAsset__050__Sultan_Adorned_104 from "../assets/items/arm/050. Sultan Adorned.png";
import ItemAsset__051__Dice_of_Destiny_105 from "../assets/items/arm/051. Dice of Destiny.png";
import ItemAsset__051__Titan_Armor_106 from "../assets/items/chest/051. Titan Armor.png";
import ItemAsset__052__Smart_Glasses_107 from "../assets/items/head/052. Smart Glasses.png";
import ItemAsset__053__David_Headphones_108 from "../assets/items/head/053. David Headphones.png";
import ItemAsset__053__Racing_Suit_109 from "../assets/items/chest/053. Racing Suit.png";
import ItemAsset__054__The_Captain_110 from "../assets/items/head/054. The Captain.png";
import ItemAsset__055__Ghillie_Suit_111 from "../assets/items/chest/055. Ghillie Suit.png";
import ItemAsset__056__Spectral_Jacket_112 from "../assets/items/chest/056. Spectral Jacket.png";
import ItemAsset__056__Demon_Mask_113 from "../assets/items/head/056. Demon Mask.png";
import ItemAsset__056__Magic_Lamp_114 from "../assets/items/arm/056. Magic Lamp.png";
import ItemAsset__057__Solar_System_Miniature_115 from "../assets/items/arm/057. Solar System Miniature.png";
import ItemAsset__057__Wisdom_Robes_116 from "../assets/items/chest/057. Wisdom Robes.png";
import ItemAsset__058__Tactical_Visor_117 from "../assets/items/head/058. Tactical_Visor.png";
import ItemAsset__058__Burning_Heart_118 from "../assets/items/arm/058. Burning Heart.png";
import ItemAsset__059__The_General_s_Robe_119 from "../assets/items/chest/059. The General_s Robe.png";
import ItemAsset__060__Smash_Totem_120 from "../assets/items/arm/060. Smash Totem.png";
import ItemAsset__062__Psyche_s_Blade_121 from "../assets/items/arm/062. Psyche_s Blade.png";
import ItemAsset_Rebel_With_A_Cause_122 from "../assets/items/chest/Rebel With A Cause.png";
import ItemAsset_Animalistic_123 from "../assets/items/head/Animalistic.png";
import ItemAsset__016__Deathadder_Queen_VBS_124 from "../assets/items/weapon/016. Deathadder Queen VBS.png";
import ItemAsset__017__Black_Mamba_King_VBS_125 from "../assets/items/weapon/017. Black Mamba King VBS.png";
import ItemAsset__018__Alpha_Sidewinder_VBS_126 from "../assets/items/weapon/018. Alpha Sidewinder VBS.png";
import ItemAsset__031__Red_Shoes_127 from "../assets/items/leg/031. Red Shoes.png";
import ItemAsset__032__Eldian_Boots_128 from "../assets/items/leg/032. Eldian Boots.png";
import ItemAsset__040__Taproot_129 from "../assets/items/leg/040. Taproot.png";
import ItemAsset__045__Pixie_Boots_130 from "../assets/items/leg/045. Pixie Boots.png";
import ItemAsset__060__Chinese_Opera_Mask_131 from "../assets/items/head/060. Chinese Opera Mask.png";
import ItemAsset__060__Red_Star_132 from "../assets/items/chest/060. Red Star.png";
import ItemAsset__061__Viking_Helmet_133 from "../assets/items/head/061. Viking Helmet.png";
import ItemAsset__062__Eyeshield_134 from "../assets/items/head/062. Eyeshield.png";
import ItemAsset__063__Burgundy_47_135 from "../assets/items/chest/063. Burgundy 47.png";
import ItemAsset__063__Prominence_136 from "../assets/items/arm/063. Prominence.png";
import ItemAsset__063__Blood_Crown_137 from "../assets/items/head/063. Blood Crown.png";
import ItemAsset__064__Featherfall_138 from "../assets/items/head/064. Featherfall.png";
import ItemAsset__064__Bloodripper_139 from "../assets/items/arm/064. Bloodripper.png";
import ItemAsset__064__Black_Flame_Dragon_140 from "../assets/items/chest/064. Black Flame Dragon.png";
import ItemAsset__065__Nova_Shield_141 from "../assets/items/arm/065. Nova Shield.png";
import ItemAsset__066__F_fnir_142 from "../assets/items/arm/066. Fáfnir.png";

export const itemAssets = {
  "007. Deathadder Queen": {
    code: "007. Deathadder Queen",
    name: "Deathadder Queen",
    displayName: "데스애더퀸",
    slotType: "weapon",
    fileName: "007. Deathadder Queen.png",
    fileNumber: 7,
    sortOrder: 0,
    grade: "epic",
    gradeLabel: "영웅",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__007__Deathadder_Queen_0,
    simulatorSelectable: true,
  },
  "008. Black Mamba King": {
    code: "008. Black Mamba King",
    name: "Black Mamba King",
    displayName: "블랙맘바킹",
    slotType: "weapon",
    fileName: "008. Black Mamba King.png",
    fileNumber: 8,
    sortOrder: 1,
    grade: "epic",
    gradeLabel: "영웅",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__008__Black_Mamba_King_1,
    simulatorSelectable: true,
  },
  "009. Alpha Sidewinder": {
    code: "009. Alpha Sidewinder",
    name: "Alpha Sidewinder",
    displayName: "슈퍼사이드와인더",
    slotType: "weapon",
    fileName: "009. Alpha Sidewinder.png",
    fileNumber: 9,
    sortOrder: 2,
    grade: "epic",
    gradeLabel: "영웅",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__009__Alpha_Sidewinder_2,
    simulatorSelectable: true,
  },
  "012. Hiking Boots": {
    code: "012. Hiking Boots",
    name: "Hiking Boots",
    displayName: "등산화",
    slotType: "leg",
    fileName: "012. Hiking Boots.png",
    fileNumber: 12,
    sortOrder: 3,
    grade: "epic",
    gradeLabel: "영웅",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__012__Hiking_Boots_3,
    simulatorSelectable: true,
  },
  "013. Virtuous Outlaw": {
    code: "013. Virtuous Outlaw",
    name: "Virtuous Outlaw",
    displayName: "로빈",
    slotType: "head",
    fileName: "013. Virtuous Outlaw.png",
    fileNumber: 13,
    sortOrder: 4,
    grade: "epic",
    gradeLabel: "영웅",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__013__Virtuous_Outlaw_4,
    simulatorSelectable: true,
  },
  "013. Glacier Crampons": {
    code: "013. Glacier Crampons",
    name: "Glacier Crampons",
    displayName: "아이젠",
    slotType: "leg",
    fileName: "013. Glacier Crampons.png",
    fileNumber: 13,
    sortOrder: 5,
    grade: "epic",
    gradeLabel: "영웅",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__013__Glacier_Crampons_5,
    simulatorSelectable: true,
  },
  "014. Steel Knee Pads": {
    code: "014. Steel Knee Pads",
    name: "Steel Knee Pads",
    displayName: "강철 무릎 보호대",
    slotType: "leg",
    fileName: "014. Steel Knee Pads.png",
    fileNumber: 14,
    sortOrder: 6,
    grade: "epic",
    gradeLabel: "영웅",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__014__Steel_Knee_Pads_6,
    simulatorSelectable: true,
  },
  "014. Sword Stopper": {
    code: "014. Sword Stopper",
    name: "Sword Stopper",
    displayName: "소드 스토퍼",
    slotType: "arm",
    fileName: "014. Sword Stopper.png",
    fileNumber: 14,
    sortOrder: 7,
    grade: "epic",
    gradeLabel: "영웅",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__014__Sword_Stopper_7,
    simulatorSelectable: true,
  },
  "014. Crystal Tiara": {
    code: "014. Crystal Tiara",
    name: "Crystal Tiara",
    displayName: "수정 티아라",
    slotType: "head",
    fileName: "014. Crystal Tiara.png",
    fileNumber: 14,
    sortOrder: 8,
    grade: "epic",
    gradeLabel: "영웅",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__014__Crystal_Tiara_8,
    simulatorSelectable: true,
  },
  "015. Feather Boots": {
    code: "015. Feather Boots",
    name: "Feather Boots",
    displayName: "경량화 부츠",
    slotType: "leg",
    fileName: "015. Feather Boots.png",
    fileNumber: 15,
    sortOrder: 9,
    grade: "epic",
    gradeLabel: "영웅",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__015__Feather_Boots_9,
    simulatorSelectable: true,
  },
  "016. Maverick Runner": {
    code: "016. Maverick Runner",
    name: "Maverick Runner",
    displayName: "매버릭 러너",
    slotType: "leg",
    fileName: "016. Maverick Runner.png",
    fileNumber: 16,
    sortOrder: 10,
    grade: "epic",
    gradeLabel: "영웅",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__016__Maverick_Runner_10,
    simulatorSelectable: true,
  },
  "016. Vital Sign Censor": {
    code: "016. Vital Sign Censor",
    name: "Vital Sign Sensor",
    displayName: "바이탈 센서",
    slotType: "arm",
    fileName: "016. Vital Sign Censor.png",
    fileNumber: 16,
    sortOrder: 11,
    grade: "epic",
    gradeLabel: "영웅",
    verifiedBy: "manual-added-item",
    needsReview: false,
    image: ItemAsset__016__Vital_Sign_Censor_11,
    simulatorSelectable: true,
  },
  "017. Helm of Banneret": {
    code: "017. Helm of Banneret",
    name: "Helm of Banneret",
    displayName: "기사단장의 투구",
    slotType: "head",
    fileName: "017. Helm of Banneret.png",
    fileNumber: 17,
    sortOrder: 12,
    grade: "epic",
    gradeLabel: "영웅",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__017__Helm_of_Banneret_12,
    simulatorSelectable: true,
  },
  "017. Creed of the Knight": {
    code: "017. Creed of the Knight",
    name: "Creed of the Knight",
    displayName: "기사의 신조",
    slotType: "arm",
    fileName: "017. Creed of the Knight.png",
    fileNumber: 17,
    sortOrder: 13,
    grade: "epic",
    gradeLabel: "영웅",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__017__Creed_of_the_Knight_13,
    simulatorSelectable: true,
  },
  "018. Bucephalus": {
    code: "018. Bucephalus",
    name: "Bucephalus",
    displayName: "부케팔로스",
    slotType: "leg",
    fileName: "018. Bucephalus.png",
    fileNumber: 18,
    sortOrder: 14,
    grade: "epic",
    gradeLabel: "영웅",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__018__Bucephalus_14,
    simulatorSelectable: true,
  },
  "018. Sheath of Shah Jahan": {
    code: "018. Sheath of Shah Jahan",
    name: "Sheath of Shah Jahan",
    displayName: "샤자한의 검집",
    slotType: "arm",
    fileName: "018. Sheath of Shah Jahan.png",
    fileNumber: 18,
    sortOrder: 15,
    grade: "epic",
    gradeLabel: "영웅",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__018__Sheath_of_Shah_Jahan_15,
    simulatorSelectable: true,
  },
  "019. Sunset Armor": {
    code: "019. Sunset Armor",
    name: "Sunset Armor",
    displayName: "석양의 갑옷",
    slotType: "chest",
    fileName: "019. Sunset Armor.png",
    fileNumber: 19,
    sortOrder: 16,
    grade: "epic",
    gradeLabel: "영웅",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__019__Sunset_Armor_16,
    simulatorSelectable: true,
  },
  "019. Burnished Aegis": {
    code: "019. Burnished Aegis",
    name: "Burnished Aegis",
    displayName: "아이기스",
    slotType: "arm",
    fileName: "019. Burnished Aegis.png",
    fileNumber: 19,
    sortOrder: 17,
    grade: "epic",
    gradeLabel: "영웅",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__019__Burnished_Aegis_17,
    simulatorSelectable: true,
  },
  "019. White Rhinos": {
    code: "019. White Rhinos",
    name: "White Rhinos",
    displayName: "클링온 부츠",
    slotType: "leg",
    fileName: "019. White Rhinos.png",
    fileNumber: 19,
    sortOrder: 18,
    grade: "epic",
    gradeLabel: "영웅",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__019__White_Rhinos_18,
    simulatorSelectable: true,
  },
  "020. Mohawk Headgear": {
    code: "020. Mohawk Headgear",
    name: "Mohawk Headgear",
    displayName: "모호크 헬멧",
    slotType: "head",
    fileName: "020. Mohawk Headgear.png",
    fileNumber: 20,
    sortOrder: 19,
    grade: "epic",
    gradeLabel: "영웅",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__020__Mohawk_Headgear_19,
    simulatorSelectable: true,
  },
  "020. Tachyon Brace": {
    code: "020. Tachyon Brace",
    name: "Tachyon Brace",
    displayName: "타키온 브레이스",
    slotType: "leg",
    fileName: "020. Tachyon Brace.png",
    fileNumber: 20,
    sortOrder: 20,
    grade: "epic",
    gradeLabel: "영웅",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__020__Tachyon_Brace_20,
    simulatorSelectable: true,
  },
  "021. Optical Camouflage Suit": {
    code: "021. Optical Camouflage Suit",
    name: "Optical Camouflage Suit",
    displayName: "광학미채 슈트",
    slotType: "chest",
    fileName: "021. Optical Camouflage Suit.png",
    fileNumber: 21,
    sortOrder: 21,
    grade: "epic",
    gradeLabel: "영웅",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__021__Optical_Camouflage_Suit_21,
    simulatorSelectable: true,
  },
  "022. Diadem": {
    code: "022. Diadem",
    name: "Diadem",
    displayName: "다이아뎀",
    slotType: "head",
    fileName: "022. Diadem.png",
    fileNumber: 22,
    sortOrder: 22,
    grade: "epic",
    gradeLabel: "영웅",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__022__Diadem_22,
    simulatorSelectable: true,
  },
  "022. Rocker_s Jacket": {
    code: "022. Rocker_s Jacket",
    name: "Rocker's Jacket",
    displayName: "락커의 자켓",
    slotType: "chest",
    fileName: "022. Rocker_s Jacket.png",
    fileNumber: 22,
    sortOrder: 23,
    grade: "epic",
    gradeLabel: "영웅",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__022__Rocker_s_Jacket_23,
    simulatorSelectable: true,
  },
  "022. Stellar Steps": {
    code: "022. Stellar Steps",
    name: "Stellar Steps",
    displayName: "스텔라 스텝",
    slotType: "leg",
    fileName: "022. Stellar Steps.png",
    fileNumber: 22,
    sortOrder: 24,
    grade: "epic",
    gradeLabel: "영웅",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__022__Stellar_Steps_24,
    simulatorSelectable: true,
  },
  "022. Plasma Arc": {
    code: "022. Plasma Arc",
    name: "Plasma Arc",
    displayName: "플라즈마 아크",
    slotType: "arm",
    fileName: "022. Plasma Arc.png",
    fileNumber: 22,
    sortOrder: 25,
    grade: "epic",
    gradeLabel: "영웅",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__022__Plasma_Arc_25,
    simulatorSelectable: true,
  },
  "023. Crusader Armor": {
    code: "023. Crusader Armor",
    name: "Crusader Armor",
    displayName: "성기사의 갑옷",
    slotType: "chest",
    fileName: "023. Crusader Armor.png",
    fileNumber: 23,
    sortOrder: 26,
    grade: "epic",
    gradeLabel: "영웅",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__023__Crusader_Armor_26,
    simulatorSelectable: true,
  },
  "023. Smart Band": {
    code: "023. Smart Band",
    name: "Smart Band",
    displayName: "스마트 밴드",
    slotType: "arm",
    fileName: "023. Smart Band.png",
    fileNumber: 23,
    sortOrder: 27,
    grade: "epic",
    gradeLabel: "영웅",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__023__Smart_Band_27,
    simulatorSelectable: true,
  },
  "023. Cowboy Hat": {
    code: "023. Cowboy Hat",
    name: "Cowboy Hat",
    displayName: "카우보이 모자",
    slotType: "head",
    fileName: "023. Cowboy Hat.png",
    fileNumber: 23,
    sortOrder: 28,
    grade: "epic",
    gradeLabel: "영웅",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__023__Cowboy_Hat_28,
    simulatorSelectable: true,
  },
  "023. Cowboy Boots": {
    code: "023. Cowboy Boots",
    name: "Cowboy Boots",
    displayName: "카우보이 부츠",
    slotType: "leg",
    fileName: "023. Cowboy Boots.png",
    fileNumber: 23,
    sortOrder: 29,
    grade: "epic",
    gradeLabel: "영웅",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__023__Cowboy_Boots_29,
    simulatorSelectable: true,
  },
  "024. Gladiator": {
    code: "024. Gladiator",
    name: "Gladiator",
    displayName: "글레디에이터",
    slotType: "leg",
    fileName: "024. Gladiator.png",
    fileNumber: 24,
    sortOrder: 30,
    grade: "epic",
    gradeLabel: "영웅",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__024__Gladiator_30,
    simulatorSelectable: true,
  },
  "024. Minuteman Armband": {
    code: "024. Minuteman Armband",
    name: "Minuteman Armband",
    displayName: "미닛맨의 표식",
    slotType: "arm",
    fileName: "024. Minuteman Armband.png",
    fileNumber: 24,
    sortOrder: 31,
    grade: "epic",
    gradeLabel: "영웅",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__024__Minuteman_Armband_31,
    simulatorSelectable: true,
  },
  "024. Amazoness_Armor": {
    code: "024. Amazoness_Armor",
    name: "Amazoness Armor",
    displayName: "아마조네스 아머",
    slotType: "chest",
    fileName: "024. Amazoness_Armor.png",
    fileNumber: 24,
    sortOrder: 32,
    grade: "epic",
    gradeLabel: "영웅",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__024__Amazoness_Armor_32,
    simulatorSelectable: true,
  },
  "024. Plasma Helmet": {
    code: "024. Plasma Helmet",
    name: "Plasma Helmet",
    displayName: "플라즈마 투구",
    slotType: "head",
    fileName: "024. Plasma Helmet.png",
    fileNumber: 24,
    sortOrder: 33,
    grade: "epic",
    gradeLabel: "영웅",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__024__Plasma_Helmet_33,
    simulatorSelectable: true,
  },
  "025. Dragon Dobok": {
    code: "025. Dragon Dobok",
    name: "Dragon Dobok",
    displayName: "용의 도복",
    slotType: "chest",
    fileName: "025. Dragon Dobok.png",
    fileNumber: 25,
    sortOrder: 34,
    grade: "epic",
    gradeLabel: "영웅",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__025__Dragon_Dobok_34,
    simulatorSelectable: true,
  },
  "025. Welding Helmet": {
    code: "025. Welding Helmet",
    name: "Welding Helmet",
    displayName: "용접 마스크",
    slotType: "head",
    fileName: "025. Welding Helmet.png",
    fileNumber: 25,
    sortOrder: 35,
    grade: "epic",
    gradeLabel: "영웅",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__025__Welding_Helmet_35,
    simulatorSelectable: true,
  },
  "027. Laced Quiver": {
    code: "027. Laced Quiver",
    name: "Laced Quiver",
    displayName: "궁기병의 화살통",
    slotType: "arm",
    fileName: "027. Laced Quiver.png",
    fileNumber: 27,
    sortOrder: 36,
    grade: "epic",
    gradeLabel: "영웅",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__027__Laced_Quiver_36,
    simulatorSelectable: true,
  },
  "027. Fox Mask": {
    code: "027. Fox Mask",
    name: "Fox Mask",
    displayName: "여우 가면",
    slotType: "head",
    fileName: "027. Fox Mask.png",
    fileNumber: 27,
    sortOrder: 37,
    grade: "epic",
    gradeLabel: "영웅",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__027__Fox_Mask_37,
    simulatorSelectable: true,
  },
  "027. Butler_s Suit": {
    code: "027. Butler_s Suit",
    name: "Butler's Suit",
    displayName: "집사복",
    slotType: "chest",
    fileName: "027. Butler_s Suit.png",
    fileNumber: 27,
    sortOrder: 38,
    grade: "epic",
    gradeLabel: "영웅",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__027__Butler_s_Suit_38,
    simulatorSelectable: true,
  },
  "028. Jolly Roger": {
    code: "028. Jolly Roger",
    name: "Jolly Roger",
    displayName: "해적 깃발",
    slotType: "arm",
    fileName: "028. Jolly Roger.png",
    fileNumber: 28,
    sortOrder: 39,
    grade: "epic",
    gradeLabel: "영웅",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__028__Jolly_Roger_39,
    simulatorSelectable: true,
  },
  "028. EOD Suit": {
    code: "028. EOD Suit",
    name: "EOD Suit",
    displayName: "EOD 슈트",
    slotType: "chest",
    fileName: "028. EOD Suit.png",
    fileNumber: 28,
    sortOrder: 40,
    grade: "epic",
    gradeLabel: "영웅",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__028__EOD_Suit_40,
    simulatorSelectable: true,
  },
  "029. The Sailor": {
    code: "029. The Sailor",
    name: "The Sailor",
    displayName: "마린 햇",
    slotType: "head",
    fileName: "029. The Sailor.png",
    fileNumber: 29,
    sortOrder: 41,
    grade: "epic",
    gradeLabel: "영웅",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__029__The_Sailor_41,
    simulatorSelectable: true,
  },
  "029. Music Box": {
    code: "029. Music Box",
    name: "Music Box",
    displayName: "오르골",
    slotType: "arm",
    fileName: "029. Music Box.png",
    fileNumber: 29,
    sortOrder: 42,
    grade: "epic",
    gradeLabel: "영웅",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__029__Music_Box_42,
    simulatorSelectable: true,
  },
  "029. Tuxedo": {
    code: "029. Tuxedo",
    name: "Tuxedo",
    displayName: "턱시도",
    slotType: "chest",
    fileName: "029. Tuxedo.png",
    fileNumber: 29,
    sortOrder: 43,
    grade: "epic",
    gradeLabel: "영웅",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__029__Tuxedo_43,
    simulatorSelectable: true,
  },
  "030. Schrödinger_s Box": {
    code: "030. Schrödinger_s Box",
    name: "Schrödinger's Box",
    displayName: "슈뢰딩거의 상자",
    slotType: "arm",
    fileName: "030. Schrödinger_s Box.png",
    fileNumber: 30,
    sortOrder: 44,
    grade: "epic",
    gradeLabel: "영웅",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__030__Schr_dinger_s_Box_44,
    simulatorSelectable: true,
  },
  "031. Changpao": {
    code: "031. Changpao",
    name: "Changpao",
    displayName: "창파오",
    slotType: "chest",
    fileName: "031. Changpao.png",
    fileNumber: 31,
    sortOrder: 45,
    grade: "epic",
    gradeLabel: "영웅",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__031__Changpao_45,
    simulatorSelectable: true,
  },
  "032. Turnout Coat": {
    code: "032. Turnout Coat",
    name: "Turnout Coat",
    displayName: "방화복",
    slotType: "chest",
    fileName: "032. Turnout Coat.png",
    fileNumber: 32,
    sortOrder: 46,
    grade: "epic",
    gradeLabel: "영웅",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__032__Turnout_Coat_46,
    simulatorSelectable: true,
  },
  "Uniform": {
    code: "Uniform",
    name: "Uniform",
    displayName: "교복",
    slotType: "chest",
    fileName: "Uniform.png",
    fileNumber: 9007199254740991,
    sortOrder: 47,
    grade: "epic",
    gradeLabel: "영웅",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset_Uniform_47,
    simulatorSelectable: true,
  },
  "010. Deathadder Queen MT": {
    code: "010. Deathadder Queen MT",
    name: "Deathadder Queen MT",
    displayName: "데스애더퀸-MT",
    slotType: "weapon",
    fileName: "010. Deathadder Queen MT.png",
    fileNumber: 10,
    sortOrder: 48,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__010__Deathadder_Queen_MT_48,
    simulatorSelectable: true,
  },
  "011. Deathadder Queen FC_": {
    code: "011. Deathadder Queen FC_",
    name: "Deathadder Queen FC",
    displayName: "데스애더퀸-FC",
    slotType: "weapon",
    fileName: "011. Deathadder Queen FC_.png",
    fileNumber: 11,
    sortOrder: 49,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__011__Deathadder_Queen_FC__49,
    simulatorSelectable: true,
  },
  "012. Black Mamba King TL": {
    code: "012. Black Mamba King TL",
    name: "Black Mamba King TL",
    displayName: "블랙맘바킹-TL",
    slotType: "weapon",
    fileName: "012. Black Mamba King TL.png",
    fileNumber: 12,
    sortOrder: 50,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__012__Black_Mamba_King_TL_50,
    simulatorSelectable: true,
  },
  "013. Black Mamba King FC": {
    code: "013. Black Mamba King FC",
    name: "Black Mamba King FC",
    displayName: "블랙맘바킹-FC",
    slotType: "weapon",
    fileName: "013. Black Mamba King FC.png",
    fileNumber: 13,
    sortOrder: 51,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__013__Black_Mamba_King_FC_51,
    simulatorSelectable: true,
  },
  "014. Alpha Siderwinder ML": {
    code: "014. Alpha Siderwinder ML",
    name: "Alpha Siderwinder ML",
    displayName: "슈퍼사이드와인더-ML",
    slotType: "weapon",
    fileName: "014. Alpha Siderwinder ML.png",
    fileNumber: 14,
    sortOrder: 52,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__014__Alpha_Siderwinder_ML_52,
    simulatorSelectable: true,
  },
  "015. Alpha Sidewinder FC": {
    code: "015. Alpha Sidewinder FC",
    name: "Alpha Sidewinder FC",
    displayName: "슈퍼사이드와인더-FC",
    slotType: "weapon",
    fileName: "015. Alpha Sidewinder FC.png",
    fileNumber: 15,
    sortOrder: 53,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__015__Alpha_Sidewinder_FC_53,
    simulatorSelectable: true,
  },
  "027. Mithril Boots": {
    code: "027. Mithril Boots",
    name: "Mithril Boots",
    displayName: "미스릴 부츠",
    slotType: "leg",
    fileName: "027. Mithril Boots.png",
    fileNumber: 27,
    sortOrder: 54,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__027__Mithril_Boots_54,
    simulatorSelectable: true,
  },
  "028. EOD Boots_EOD 부츠": {
    code: "028. EOD Boots_EOD 부츠",
    name: "EOD Boots EOD 부츠",
    displayName: "EOD 부츠",
    slotType: "leg",
    fileName: "028. EOD Boots_EOD 부츠.png",
    fileNumber: 28,
    sortOrder: 55,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__028__EOD_Boots_EOD____55,
    simulatorSelectable: true,
  },
  "030. Mithril Helm": {
    code: "030. Mithril Helm",
    name: "Mithril Helm",
    displayName: "미스릴 투구",
    slotType: "head",
    fileName: "030. Mithril Helm.png",
    fileNumber: 30,
    sortOrder: 56,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__030__Mithril_Helm_56,
    simulatorSelectable: true,
  },
  "030. Iron Maiden": {
    code: "030. Iron Maiden",
    name: "Iron Maiden",
    displayName: "아이언 메이든",
    slotType: "leg",
    fileName: "030. Iron Maiden.png",
    fileNumber: 30,
    sortOrder: 57,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__030__Iron_Maiden_57,
    simulatorSelectable: true,
  },
  "031. Laurel Wreath": {
    code: "031. Laurel Wreath",
    name: "Laurel Wreath",
    displayName: "월계관",
    slotType: "head",
    fileName: "031. Laurel Wreath.png",
    fileNumber: 31,
    sortOrder: 58,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__031__Laurel_Wreath_58,
    simulatorSelectable: true,
  },
  "031. Boots of Hermes": {
    code: "031. Boots of Hermes",
    name: "Boots of Hermes",
    displayName: "헤르메스의 부츠",
    slotType: "leg",
    fileName: "031. Boots of Hermes.png",
    fileNumber: 31,
    sortOrder: 59,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__031__Boots_of_Hermes_59,
    simulatorSelectable: true,
  },
  "032. Mithril Shield": {
    code: "032. Mithril Shield",
    name: "Mithril Shield",
    displayName: "미스릴 방패",
    slotType: "arm",
    fileName: "032. Mithril Shield.png",
    fileNumber: 32,
    sortOrder: 60,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__032__Mithril_Shield_60,
    simulatorSelectable: true,
  },
  "032. Blade Boots": {
    code: "032. Blade Boots",
    name: "Blade Boots",
    displayName: "블레이드 부츠",
    slotType: "leg",
    fileName: "032. Blade Boots.png",
    fileNumber: 32,
    sortOrder: 61,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__032__Blade_Boots_61,
    simulatorSelectable: true,
  },
  "032. Crusader Helmet": {
    code: "032. Crusader Helmet",
    name: "Crusader Helmet",
    displayName: "성기사의 투구",
    slotType: "head",
    fileName: "032. Crusader Helmet.png",
    fileNumber: 32,
    sortOrder: 62,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__032__Crusader_Helmet_62,
    simulatorSelectable: true,
  },
  "033. Mithril Armor": {
    code: "033. Mithril Armor",
    name: "Mithril Armor",
    displayName: "미스릴 갑옷",
    slotType: "chest",
    fileName: "033. Mithril Armor.png",
    fileNumber: 33,
    sortOrder: 63,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__033__Mithril_Armor_63,
    simulatorSelectable: true,
  },
  "033. Alexander": {
    code: "033. Alexander",
    name: "Alexander",
    displayName: "알렉산드로스",
    slotType: "leg",
    fileName: "033. Alexander.png",
    fileNumber: 33,
    sortOrder: 64,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__033__Alexander_64,
    simulatorSelectable: true,
  },
  "033. Cube Watch": {
    code: "033. Cube Watch",
    name: "Cube Watch",
    displayName: "큐브 워치",
    slotType: "arm",
    fileName: "033. Cube Watch.png",
    fileNumber: 33,
    sortOrder: 65,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__033__Cube_Watch_65,
    simulatorSelectable: true,
  },
  "034. Battle Suit": {
    code: "034. Battle Suit",
    name: "Battle Suit",
    displayName: "배틀 슈트",
    slotType: "chest",
    fileName: "034. Battle Suit.png",
    fileNumber: 34,
    sortOrder: 66,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__034__Battle_Suit_66,
    simulatorSelectable: true,
  },
  "034. Elysian Halo": {
    code: "034. Elysian Halo",
    name: "Elysian Halo",
    displayName: "천사의 고리",
    slotType: "head",
    fileName: "034. Elysian Halo.png",
    fileNumber: 34,
    sortOrder: 67,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__034__Elysian_Halo_67,
    simulatorSelectable: true,
  },
  "035. Blazing Dress": {
    code: "035. Blazing Dress",
    name: "Blazing Dress",
    displayName: "불꽃 드레스",
    slotType: "chest",
    fileName: "035. Blazing Dress.png",
    fileNumber: 35,
    sortOrder: 68,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__035__Blazing_Dress_68,
    simulatorSelectable: true,
  },
  "035. Fallen Pegasus": {
    code: "035. Fallen Pegasus",
    name: "Fallen Pegasus",
    displayName: "빛의 증표",
    slotType: "head",
    fileName: "035. Fallen Pegasus.png",
    fileNumber: 35,
    sortOrder: 69,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__035__Fallen_Pegasus_69,
    simulatorSelectable: true,
  },
  "035. Wild Walkers": {
    code: "035. Wild Walkers",
    name: "Wild Walkers",
    displayName: "와일드 워커",
    slotType: "leg",
    fileName: "035. Wild Walkers.png",
    fileNumber: 35,
    sortOrder: 70,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__035__Wild_Walkers_70,
    simulatorSelectable: true,
  },
  "036. Galaxy Steps": {
    code: "036. Galaxy Steps",
    name: "Galaxy Steps",
    displayName: "갤럭시 스텝",
    slotType: "leg",
    fileName: "036. Galaxy Steps.png",
    fileNumber: 36,
    sortOrder: 71,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__036__Galaxy_Steps_71,
    simulatorSelectable: true,
  },
  "036. Radar": {
    code: "036. Radar",
    name: "Radar",
    displayName: "레이더",
    slotType: "arm",
    fileName: "036. Radar.png",
    fileNumber: 36,
    sortOrder: 72,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__036__Radar_72,
    simulatorSelectable: true,
  },
  "036. Mithril Crop": {
    code: "036. Mithril Crop",
    name: "Mithril Crop",
    displayName: "미스릴 크롭",
    slotType: "chest",
    fileName: "036. Mithril Crop.png",
    fileNumber: 36,
    sortOrder: 73,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__036__Mithril_Crop_73,
    simulatorSelectable: true,
  },
  "037. Mirage Lace-Ups": {
    code: "037. Mirage Lace-Ups",
    name: "Mirage Lace-Ups",
    displayName: "미라지 워커",
    slotType: "leg",
    fileName: "037. Mirage Lace-Ups.png",
    fileNumber: 37,
    sortOrder: 74,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__037__Mirage_Lace_Ups_74,
    simulatorSelectable: true,
  },
  "037. Auto-arms": {
    code: "037. Auto-arms",
    name: "Auto-arms",
    displayName: "오토-암즈",
    slotType: "arm",
    fileName: "037. Auto-arms.png",
    fileNumber: 37,
    sortOrder: 75,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__037__Auto_arms_75,
    simulatorSelectable: true,
  },
  "038. Centipede_s Pauldron": {
    code: "038. Centipede_s Pauldron",
    name: "Centipede's Pauldron",
    displayName: "가시지네 견갑",
    slotType: "arm",
    fileName: "038. Centipede_s Pauldron.png",
    fileNumber: 38,
    sortOrder: 76,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__038__Centipede_s_Pauldron_76,
    simulatorSelectable: true,
  },
  "038. Racing Boots": {
    code: "038. Racing Boots",
    name: "Racing Boots",
    displayName: "레이싱 부츠",
    slotType: "leg",
    fileName: "038. Racing Boots.png",
    fileNumber: 38,
    sortOrder: 77,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__038__Racing_Boots_77,
    simulatorSelectable: true,
  },
  "039. Space Boots": {
    code: "039. Space Boots",
    name: "Space Boots",
    displayName: "스페이스 부츠",
    slotType: "leg",
    fileName: "039. Space Boots.png",
    fileNumber: 39,
    sortOrder: 78,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__039__Space_Boots_78,
    simulatorSelectable: true,
  },
  "039. Áo Dài": {
    code: "039. Áo Dài",
    name: "Áo Dài",
    displayName: "아오자이",
    slotType: "chest",
    fileName: "039. Áo Dài.png",
    fileNumber: 39,
    sortOrder: 79,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__039___o_D_i_79,
    simulatorSelectable: true,
  },
  "039. The Star of the Wilds": {
    code: "039. The Star of the Wilds",
    name: "The Star of the Wilds",
    displayName: "황야의 별",
    slotType: "head",
    fileName: "039. The Star of the Wilds.png",
    fileNumber: 39,
    sortOrder: 80,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__039__The_Star_of_the_Wilds_80,
    simulatorSelectable: true,
  },
  "040. Shield of Kings": {
    code: "040. Shield of Kings",
    name: "Shield of Kings",
    displayName: "샤를마뉴의 방패",
    slotType: "arm",
    fileName: "040. Shield of Kings.png",
    fileNumber: 40,
    sortOrder: 81,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__040__Shield_of_Kings_81,
    simulatorSelectable: true,
  },
  "040. Tactical Shoes": {
    code: "040. Tactical Shoes",
    name: "Tactical Shoes",
    displayName: "택티컬 슈즈",
    slotType: "leg",
    fileName: "040. Tactical Shoes.png",
    fileNumber: 40,
    sortOrder: 82,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-added-item",
    needsReview: false,
    image: ItemAsset__040__Tactical_Shoes_82,
    simulatorSelectable: true,
  },
  "040. Phantom Jacket": {
    code: "040. Phantom Jacket",
    name: "Phantom Jacket",
    displayName: "팬텀 자켓",
    slotType: "chest",
    fileName: "040. Phantom Jacket.png",
    fileNumber: 40,
    sortOrder: 83,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__040__Phantom_Jacket_83,
    simulatorSelectable: true,
  },
  "041. Guardian Suit": {
    code: "041. Guardian Suit",
    name: "Guardian Suit",
    displayName: "가디언 슈트",
    slotType: "chest",
    fileName: "041. Guardian Suit.png",
    fileNumber: 41,
    sortOrder: 84,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__041__Guardian_Suit_84,
    simulatorSelectable: true,
  },
  "041. Dwarf_s Helmet": {
    code: "041. Dwarf_s Helmet",
    name: "Dwarf's Helmet",
    displayName: "드워프의 투구",
    slotType: "head",
    fileName: "041. Dwarf_s Helmet.png",
    fileNumber: 41,
    sortOrder: 85,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__041__Dwarf_s_Helmet_85,
    simulatorSelectable: true,
  },
  "042. Chain of Thorns": {
    code: "042. Chain of Thorns",
    name: "Chain of Thorns",
    displayName: "서슬가시 체인",
    slotType: "arm",
    fileName: "042. Chain of Thorns.png",
    fileNumber: 42,
    sortOrder: 86,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__042__Chain_of_Thorns_86,
    simulatorSelectable: true,
  },
  "042. Twilight": {
    code: "042. Twilight",
    name: "Twilight",
    displayName: "트와일라잇",
    slotType: "head",
    fileName: "042. Twilight.png",
    fileNumber: 42,
    sortOrder: 87,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__042__Twilight_87,
    simulatorSelectable: true,
  },
  "043. Beautiful Garnment": {
    code: "043. Beautiful Garnment",
    name: "Beautiful Garnment",
    displayName: "선녀강림",
    slotType: "chest",
    fileName: "043. Beautiful Garnment.png",
    fileNumber: 43,
    sortOrder: 88,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__043__Beautiful_Garnment_88,
    simulatorSelectable: true,
  },
  "043. GPNVG": {
    code: "043. GPNVG",
    name: "GPNVG",
    displayName: "쿼드 아이",
    slotType: "head",
    fileName: "043. GPNVG.png",
    fileNumber: 43,
    sortOrder: 89,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__043__GPNVG_89,
    simulatorSelectable: true,
  },
  "044. Specter": {
    code: "044. Specter",
    name: "Specter",
    displayName: "고스트",
    slotType: "chest",
    fileName: "044. Specter.png",
    fileNumber: 44,
    sortOrder: 90,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__044__Specter_90,
    simulatorSelectable: true,
  },
  "044. Helix": {
    code: "044. Helix",
    name: "Helix",
    displayName: "헬릭스",
    slotType: "arm",
    fileName: "044. Helix.png",
    fileNumber: 44,
    sortOrder: 91,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__044__Helix_91,
    simulatorSelectable: true,
  },
  "045. Mythril Armband": {
    code: "045. Mythril Armband",
    name: "Mythril Armband",
    displayName: "미스릴 완장",
    slotType: "arm",
    fileName: "045. Mythril Armband.png",
    fileNumber: 45,
    sortOrder: 92,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__045__Mythril_Armband_92,
    simulatorSelectable: true,
  },
  "046. Blaster Helmet": {
    code: "046. Blaster Helmet",
    name: "Blaster Helmet",
    displayName: "블래스터 헬멧",
    slotType: "head",
    fileName: "046. Blaster Helmet.png",
    fileNumber: 46,
    sortOrder: 93,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__046__Blaster_Helmet_93,
    simulatorSelectable: true,
  },
  "046. Omertà": {
    code: "046. Omertà",
    name: "Omertà",
    displayName: "오메르타",
    slotType: "chest",
    fileName: "046. Omertà.png",
    fileNumber: 46,
    sortOrder: 94,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__046__Omert__94,
    simulatorSelectable: true,
  },
  "046. Buccaneer Doubloon": {
    code: "046. Buccaneer Doubloon",
    name: "Buccaneer Doubloon",
    displayName: "해적의 증표",
    slotType: "arm",
    fileName: "046. Buccaneer Doubloon.png",
    fileNumber: 46,
    sortOrder: 95,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__046__Buccaneer_Doubloon_95,
    simulatorSelectable: true,
  },
  "047. Moonlight Pendant": {
    code: "047. Moonlight Pendant",
    name: "Moonlight Pendant",
    displayName: "달빛 펜던트",
    slotType: "arm",
    fileName: "047. Moonlight Pendant.png",
    fileNumber: 47,
    sortOrder: 96,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__047__Moonlight_Pendant_96,
    simulatorSelectable: true,
  },
  "047. Shooting Star Jacket": {
    code: "047. Shooting Star Jacket",
    name: "Shooting Star Jacket",
    displayName: "슈팅스타 자켓",
    slotType: "chest",
    fileName: "047. Shooting Star Jacket.png",
    fileNumber: 47,
    sortOrder: 97,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__047__Shooting_Star_Jacket_97,
    simulatorSelectable: true,
  },
  "047. Commander Headset": {
    code: "047. Commander Headset",
    name: "Commander Headset",
    displayName: "커맨더 헤드셋",
    slotType: "head",
    fileName: "047. Commander Headset.png",
    fileNumber: 47,
    sortOrder: 98,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__047__Commander_Headset_98,
    simulatorSelectable: true,
  },
  "048. Blue Flames": {
    code: "048. Blue Flames",
    name: "Blue Flames",
    displayName: "스파크 실드",
    slotType: "head",
    fileName: "048. Blue Flames.png",
    fileNumber: 48,
    sortOrder: 99,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__048__Blue_Flames_99,
    simulatorSelectable: true,
  },
  "049. Mythril Quiver": {
    code: "049. Mythril Quiver",
    name: "Mythril Quiver",
    displayName: "미스릴 퀴버",
    slotType: "arm",
    fileName: "049. Mythril Quiver.png",
    fileNumber: 49,
    sortOrder: 100,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__049__Mythril_Quiver_100,
    simulatorSelectable: true,
  },
  "049. Bunny Hat": {
    code: "049. Bunny Hat",
    name: "Bunny Hat",
    displayName: "바니햇",
    slotType: "head",
    fileName: "049. Bunny Hat.png",
    fileNumber: 49,
    sortOrder: 101,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__049__Bunny_Hat_101,
    simulatorSelectable: true,
  },
  "049. Tactical Armor": {
    code: "049. Tactical Armor",
    name: "Tactical Armor",
    displayName: "택티컬 아머",
    slotType: "chest",
    fileName: "049. Tactical Armor.png",
    fileNumber: 49,
    sortOrder: 102,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__049__Tactical_Armor_102,
    simulatorSelectable: true,
  },
  "050. Legatus": {
    code: "050. Legatus",
    name: "Legatus",
    displayName: "레가투스",
    slotType: "head",
    fileName: "050. Legatus.png",
    fileNumber: 50,
    sortOrder: 103,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__050__Legatus_103,
    simulatorSelectable: true,
  },
  "050. Sultan Adorned": {
    code: "050. Sultan Adorned",
    name: "Sultan Adorned",
    displayName: "살라딘의 화살통",
    slotType: "arm",
    fileName: "050. Sultan Adorned.png",
    fileNumber: 50,
    sortOrder: 104,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__050__Sultan_Adorned_104,
    simulatorSelectable: true,
  },
  "051. Dice of Destiny": {
    code: "051. Dice of Destiny",
    name: "Dice of Destiny",
    displayName: "운명의 주사위",
    slotType: "arm",
    fileName: "051. Dice of Destiny.png",
    fileNumber: 51,
    sortOrder: 105,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__051__Dice_of_Destiny_105,
    simulatorSelectable: true,
  },
  "051. Titan Armor": {
    code: "051. Titan Armor",
    name: "Titan Armor",
    displayName: "타이탄 아머",
    slotType: "chest",
    fileName: "051. Titan Armor.png",
    fileNumber: 51,
    sortOrder: 106,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__051__Titan_Armor_106,
    simulatorSelectable: true,
  },
  "052. Smart Glasses": {
    code: "052. Smart Glasses",
    name: "Smart Glasses",
    displayName: "인사이트",
    slotType: "head",
    fileName: "052. Smart Glasses.png",
    fileNumber: 52,
    sortOrder: 107,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__052__Smart_Glasses_107,
    simulatorSelectable: true,
  },
  "053. David Headphones": {
    code: "053. David Headphones",
    name: "David Headphones",
    displayName: "다비드 헤드폰",
    slotType: "head",
    fileName: "053. David Headphones.png",
    fileNumber: 53,
    sortOrder: 108,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__053__David_Headphones_108,
    simulatorSelectable: true,
  },
  "053. Racing Suit": {
    code: "053. Racing Suit",
    name: "Racing Suit",
    displayName: "레이싱 슈트",
    slotType: "chest",
    fileName: "053. Racing Suit.png",
    fileNumber: 53,
    sortOrder: 109,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__053__Racing_Suit_109,
    simulatorSelectable: true,
  },
  "054. The Captain": {
    code: "054. The Captain",
    name: "The Captain",
    displayName: "캡틴 햇",
    slotType: "head",
    fileName: "054. The Captain.png",
    fileNumber: 54,
    sortOrder: 110,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__054__The_Captain_110,
    simulatorSelectable: true,
  },
  "055. Ghillie Suit": {
    code: "055. Ghillie Suit",
    name: "Ghillie Suit",
    displayName: "길리 슈트",
    slotType: "chest",
    fileName: "055. Ghillie Suit.png",
    fileNumber: 55,
    sortOrder: 111,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__055__Ghillie_Suit_111,
    simulatorSelectable: true,
  },
  "056. Spectral Jacket": {
    code: "056. Spectral Jacket",
    name: "Spectral Jacket",
    displayName: "스펙터",
    slotType: "chest",
    fileName: "056. Spectral Jacket.png",
    fileNumber: 56,
    sortOrder: 112,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__056__Spectral_Jacket_112,
    simulatorSelectable: true,
  },
  "056. Demon Mask": {
    code: "056. Demon Mask",
    name: "Demon Mask",
    displayName: "오니 가면",
    slotType: "head",
    fileName: "056. Demon Mask.png",
    fileNumber: 56,
    sortOrder: 113,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__056__Demon_Mask_113,
    simulatorSelectable: true,
  },
  "056. Magic Lamp": {
    code: "056. Magic Lamp",
    name: "Magic Lamp",
    displayName: "요술램프",
    slotType: "arm",
    fileName: "056. Magic Lamp.png",
    fileNumber: 56,
    sortOrder: 114,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__056__Magic_Lamp_114,
    simulatorSelectable: true,
  },
  "057. Solar System Miniature": {
    code: "057. Solar System Miniature",
    name: "Solar System Miniature",
    displayName: "미니어쳐 솔라 시스템",
    slotType: "arm",
    fileName: "057. Solar System Miniature.png",
    fileNumber: 57,
    sortOrder: 115,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__057__Solar_System_Miniature_115,
    simulatorSelectable: true,
  },
  "057. Wisdom Robes": {
    code: "057. Wisdom Robes",
    name: "Wisdom Robes",
    displayName: "현자의 로브",
    slotType: "chest",
    fileName: "057. Wisdom Robes.png",
    fileNumber: 57,
    sortOrder: 116,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__057__Wisdom_Robes_116,
    simulatorSelectable: true,
  },
  "058. Tactical_Visor": {
    code: "058. Tactical_Visor",
    name: "Tactical Visor",
    displayName: "택티컬 바이저",
    slotType: "head",
    fileName: "058. Tactical_Visor.png",
    fileNumber: 58,
    sortOrder: 117,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__058__Tactical_Visor_117,
    simulatorSelectable: true,
  },
  "058. Burning Heart": {
    code: "058. Burning Heart",
    name: "Burning Heart",
    displayName: "하트 온 파이어",
    slotType: "arm",
    fileName: "058. Burning Heart.png",
    fileNumber: 58,
    sortOrder: 118,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__058__Burning_Heart_118,
    simulatorSelectable: true,
  },
  "059. The General_s Robe": {
    code: "059. The General_s Robe",
    name: "The General's Robe",
    displayName: "화령장",
    slotType: "chest",
    fileName: "059. The General_s Robe.png",
    fileNumber: 59,
    sortOrder: 119,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__059__The_General_s_Robe_119,
    simulatorSelectable: true,
  },
  "060. Smash Totem": {
    code: "060. Smash Totem",
    name: "Smash Totem",
    displayName: "토템",
    slotType: "arm",
    fileName: "060. Smash Totem.png",
    fileNumber: 60,
    sortOrder: 120,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__060__Smash_Totem_120,
    simulatorSelectable: true,
  },
  "062. Psyche_s Blade": {
    code: "062. Psyche_s Blade",
    name: "Psyche's Blade",
    displayName: "프시케의 칼날",
    slotType: "arm",
    fileName: "062. Psyche_s Blade.png",
    fileNumber: 62,
    sortOrder: 121,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__062__Psyche_s_Blade_121,
    simulatorSelectable: true,
  },
  "Rebel With A Cause": {
    code: "Rebel With A Cause",
    name: "Rebel With A Cause",
    displayName: "반역의 의지",
    slotType: "chest",
    fileName: "Rebel With A Cause.png",
    fileNumber: 9007199254740991,
    sortOrder: 122,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset_Rebel_With_A_Cause_122,
    simulatorSelectable: true,
  },
  "Animalistic": {
    code: "Animalistic",
    name: "Animalistic",
    displayName: "야생의 허기",
    slotType: "head",
    fileName: "Animalistic.png",
    fileNumber: 9007199254740991,
    sortOrder: 123,
    grade: "legend",
    gradeLabel: "전설",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset_Animalistic_123,
    simulatorSelectable: true,
  },
  "016. Deathadder Queen VBS": {
    code: "016. Deathadder Queen VBS",
    name: "Deathadder Queen VBS",
    displayName: "데스애더퀸-VBS",
    slotType: "weapon",
    fileName: "016. Deathadder Queen VBS.png",
    fileNumber: 16,
    sortOrder: 124,
    grade: "mythic",
    gradeLabel: "초월",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__016__Deathadder_Queen_VBS_124,
    simulatorSelectable: true,
  },
  "017. Black Mamba King VBS": {
    code: "017. Black Mamba King VBS",
    name: "Black Mamba King VBS",
    displayName: "블랙맘바킹-VBS",
    slotType: "weapon",
    fileName: "017. Black Mamba King VBS.png",
    fileNumber: 17,
    sortOrder: 125,
    grade: "mythic",
    gradeLabel: "초월",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__017__Black_Mamba_King_VBS_125,
    simulatorSelectable: true,
  },
  "018. Alpha Sidewinder VBS": {
    code: "018. Alpha Sidewinder VBS",
    name: "Alpha Sidewinder VBS",
    displayName: "슈퍼사이드와인더-VBS",
    slotType: "weapon",
    fileName: "018. Alpha Sidewinder VBS.png",
    fileNumber: 18,
    sortOrder: 126,
    grade: "mythic",
    gradeLabel: "초월",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__018__Alpha_Sidewinder_VBS_126,
    simulatorSelectable: true,
  },
  "031. Red Shoes": {
    code: "031. Red Shoes",
    name: "Red Shoes",
    displayName: "분홍신",
    slotType: "leg",
    fileName: "031. Red Shoes.png",
    fileNumber: 31,
    sortOrder: 127,
    grade: "mythic",
    gradeLabel: "초월",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__031__Red_Shoes_127,
    simulatorSelectable: true,
  },
  "032. Eldian Boots": {
    code: "032. Eldian Boots",
    name: "Eldian Boots",
    displayName: "엘디안 부츠",
    slotType: "leg",
    fileName: "032. Eldian Boots.png",
    fileNumber: 32,
    sortOrder: 128,
    grade: "mythic",
    gradeLabel: "초월",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__032__Eldian_Boots_128,
    simulatorSelectable: true,
  },
  "040. Taproot": {
    code: "040. Taproot",
    name: "Taproot",
    displayName: "탭루트",
    slotType: "leg",
    fileName: "040. Taproot.png",
    fileNumber: 40,
    sortOrder: 129,
    grade: "mythic",
    gradeLabel: "초월",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__040__Taproot_129,
    simulatorSelectable: true,
  },
  "045. Pixie Boots": {
    code: "045. Pixie Boots",
    name: "Pixie Boots",
    displayName: "픽시부츠",
    slotType: "leg",
    fileName: "045. Pixie Boots.png",
    fileNumber: 45,
    sortOrder: 130,
    grade: "mythic",
    gradeLabel: "초월",
    verifiedBy: "manual-added-item",
    needsReview: false,
    image: ItemAsset__045__Pixie_Boots_130,
    simulatorSelectable: true,
  },
  "060. Chinese Opera Mask": {
    code: "060. Chinese Opera Mask",
    name: "Chinese Opera Mask",
    displayName: "변검",
    slotType: "head",
    fileName: "060. Chinese Opera Mask.png",
    fileNumber: 60,
    sortOrder: 131,
    grade: "mythic",
    gradeLabel: "초월",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__060__Chinese_Opera_Mask_131,
    simulatorSelectable: true,
  },
  "060. Red Star": {
    code: "060. Red Star",
    name: "Red Star",
    displayName: "붉은 별빛",
    slotType: "chest",
    fileName: "060. Red Star.png",
    fileNumber: 60,
    sortOrder: 132,
    grade: "mythic",
    gradeLabel: "초월",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__060__Red_Star_132,
    simulatorSelectable: true,
  },
  "061. Viking Helmet": {
    code: "061. Viking Helmet",
    name: "Viking Helmet",
    displayName: "발할라의 투구",
    slotType: "head",
    fileName: "061. Viking Helmet.png",
    fileNumber: 61,
    sortOrder: 133,
    grade: "mythic",
    gradeLabel: "초월",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__061__Viking_Helmet_133,
    simulatorSelectable: true,
  },
  "062. Eyeshield": {
    code: "062. Eyeshield",
    name: "Eyeshield",
    displayName: "아이실드",
    slotType: "head",
    fileName: "062. Eyeshield.png",
    fileNumber: 62,
    sortOrder: 134,
    grade: "mythic",
    gradeLabel: "초월",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__062__Eyeshield_134,
    simulatorSelectable: true,
  },
  "063. Burgundy 47": {
    code: "063. Burgundy 47",
    name: "Burgundy 47",
    displayName: "버건디 47",
    slotType: "chest",
    fileName: "063. Burgundy 47.png",
    fileNumber: 63,
    sortOrder: 135,
    grade: "mythic",
    gradeLabel: "초월",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__063__Burgundy_47_135,
    simulatorSelectable: true,
  },
  "063. Prominence": {
    code: "063. Prominence",
    name: "Prominence",
    displayName: "프로미넌스",
    slotType: "arm",
    fileName: "063. Prominence.png",
    fileNumber: 63,
    sortOrder: 136,
    grade: "mythic",
    gradeLabel: "초월",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__063__Prominence_136,
    simulatorSelectable: true,
  },
  "063. Blood Crown": {
    code: "063. Blood Crown",
    name: "Blood Crown",
    displayName: "핏빛 왕관",
    slotType: "head",
    fileName: "063. Blood Crown.png",
    fileNumber: 63,
    sortOrder: 137,
    grade: "mythic",
    gradeLabel: "초월",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__063__Blood_Crown_137,
    simulatorSelectable: true,
  },
  "064. Featherfall": {
    code: "064. Featherfall",
    name: "Featherfall",
    displayName: "페더폴",
    slotType: "head",
    fileName: "064. Featherfall.png",
    fileNumber: 64,
    sortOrder: 138,
    grade: "mythic",
    gradeLabel: "초월",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__064__Featherfall_138,
    simulatorSelectable: true,
  },
  "064. Bloodripper": {
    code: "064. Bloodripper",
    name: "Bloodripper",
    displayName: "혈사조",
    slotType: "arm",
    fileName: "064. Bloodripper.png",
    fileNumber: 64,
    sortOrder: 139,
    grade: "mythic",
    gradeLabel: "초월",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__064__Bloodripper_139,
    simulatorSelectable: true,
  },
  "064. Black Flame Dragon": {
    code: "064. Black Flame Dragon",
    name: "Black Flame Dragon",
    displayName: "흑염룡의 갑주",
    slotType: "chest",
    fileName: "064. Black Flame Dragon.png",
    fileNumber: 64,
    sortOrder: 140,
    grade: "mythic",
    gradeLabel: "초월",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__064__Black_Flame_Dragon_140,
    simulatorSelectable: true,
  },
  "065. Nova Shield": {
    code: "065. Nova Shield",
    name: "Nova Shield",
    displayName: "노바 실드",
    slotType: "arm",
    fileName: "065. Nova Shield.png",
    fileNumber: 65,
    sortOrder: 141,
    grade: "mythic",
    gradeLabel: "초월",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__065__Nova_Shield_141,
    simulatorSelectable: true,
  },
  "066. Fáfnir": {
    code: "066. Fáfnir",
    name: "Fáfnir",
    displayName: "파프니르",
    slotType: "arm",
    fileName: "066. Fáfnir.png",
    fileNumber: 66,
    sortOrder: 142,
    grade: "mythic",
    gradeLabel: "초월",
    verifiedBy: "manual-verified",
    needsReview: false,
    image: ItemAsset__066__F_fnir_142,
    simulatorSelectable: true,
  },
};
